/* Completa el look / Súmale — Tres60LAB
   Agrega complementos al carrito sin recargar, tanto en la ficha de producto
   como dentro del cart drawer. Usa delegación de eventos para que siga
   funcionando después de que el carrito se vuelva a dibujar. */
(function () {
  'use strict';

  if (window.__celReady) return;
  window.__celReady = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function refreshCart(sections) {
    if (!sections) return;
    var parser = new DOMParser();

    if (sections['cart-drawer']) {
      var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      var src = doc.querySelector('#CartDrawer');
      var dst = document.querySelector('#CartDrawer');
      if (src && dst) dst.innerHTML = src.innerHTML;
    }

    if (sections['cart-icon-bubble']) {
      var doc2 = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      var src2 = doc2.querySelector('#cart-icon-bubble') || doc2.body.firstElementChild;
      var dst2 = document.querySelector('#cart-icon-bubble');
      if (src2 && dst2) dst2.innerHTML = src2.innerHTML;
    }
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try {
        drawer.classList.remove('is-empty');
        drawer.open();
        return true;
      } catch (e) {}
    }
    return false;
  }

  function setStatus(scope, text) {
    if (!scope) return;
    var el = scope.querySelector('[data-cel-status]');
    if (el) el.textContent = text || '';
  }

  function variantIdsFrom(cards) {
    var ids = [];
    cards.forEach(function (card) {
      var input = card.querySelector('[data-cel-variant]');
      if (input && input.value) ids.push(parseInt(input.value, 10));
    });
    return ids;
  }

  function addToCart(ids, button, scope) {
    if (!ids.length) return;

    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'AGREGANDO…';
    setStatus(scope, '');

    var items = ids.map(function (id) {
      return { id: id, quantity: 1 };
    });

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status || data.errors) {
          throw new Error(data.description || data.message || 'Error');
        }

        button.textContent = ids.length > 1 ? 'LOOK AGREGADO ✓' : 'AGREGADO ✓';
        button.classList.add('is-done');

        var wasOpen = !!document.querySelector('cart-drawer.active, cart-drawer.animate');

        // Se deja ver la confirmación un momento antes de redibujar el carrito.
        setTimeout(function () {
          refreshCart(data.sections);
          if (!openDrawer() && !wasOpen) {
            setStatus(
              scope,
              ids.length > 1
                ? 'Agregamos ' + ids.length + ' piezas al carrito.'
                : 'Agregado al carrito.'
            );
          }
        }, 550);
      })
      .catch(function (err) {
        console.error('[completa-el-look]', err);
        button.textContent = 'NO DISPONIBLE';
        setStatus(scope, 'No pudimos agregarlo. Puede que se haya agotado.');
      })
      .finally(function () {
        setTimeout(function () {
          if (!button.isConnected) return;
          button.disabled = false;
          button.textContent = original;
          button.classList.remove('is-done');
        }, 2500);
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var addBtn = target.closest('[data-cel-add]');
    if (addBtn) {
      var card = addBtn.closest('[data-cel-card]');
      if (!card) return;
      event.preventDefault();
      addToCart(variantIdsFrom([card]), addBtn, addBtn.closest('[data-cel]'));
      return;
    }

    var allBtn = target.closest('[data-cel-add-all]');
    if (allBtn) {
      var scope = allBtn.closest('[data-cel]');
      if (!scope) return;
      event.preventDefault();
      var cards = Array.prototype.slice.call(scope.querySelectorAll('[data-cel-card]'));
      addToCart(variantIdsFrom(cards), allBtn, scope);
    }
  });
})();
